import { PresentationBundleKind } from '@/types/schema';

import { BundleSaveDescriptor } from '../presentationSave.types';
import { createGeneratedBundleCardDescriptor } from './generatedBundleCardDescriptor';

export const willBundleDescriptor: BundleSaveDescriptor =
  createGeneratedBundleCardDescriptor({
    kind: PresentationBundleKind.WillBundle,
    field: 'willBundleConfiguration',
    read: (bundle) => {
      const config = bundle.willBundleConfiguration;
      if (!config) return undefined;
      return {
        id: config.id,
        displayName: config.displayName,
        itemsPerPage: config.itemsPerPage,
        cards: config.wills.map((will) => ({
          id: will.id,
          name: will.grantorName,
          items: will.items,
        })),
      };
    },
  });
